<!-- [closable] is mirrored to dismissableMask: PrimeNG only binds the mask-click
     (outside-click) handler when closable AND dismissableMask are both true. So
     dismissable modals (consent) actually close on outside click; they have no
     header, so no X icon appears. -->
<p-dialog
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    (onHide)="onDialogHide()"
    (onShow)="onDialogShow()"
    [modal]="true"
    [closable]="dismissableMask()"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="dismissableMask()"
    [closeOnEscape]="closeOnEscape()"
    [focusOnShow]="false"
    [showHeader]="!!title"
    [styleClass]="dialogStyleClass"
    maskStyleClass="app-modal-mask"
    [pt]="{ root: { 'data-testid': 'modal_root', 'data-modal-type': type } }"
    appendTo="body">

    @if (title) {
    <ng-template pTemplate="header">
        <h5 [innerHTML]="title" class="modal-title text-center w-full"></h5>
    </ng-template>
    }

    @if (content) {
    <div class="modal-body pt-0 pe-0 ps-0 text-center font-medium">
        <p class="modal-body-data" [innerHTML]="content" data-testid="modal_message"></p>
        @if (type == 'message' && size == 'terms') {
        <div class="modal-footer flex justify-center mt-5">
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="dismiss()" data-testid="modal_confirm">
                {{ 'common.confirm' | transloco }}
            </button>
        </div>
        }
        @if (type == 'consent') {
        <div class="modal-footer flex justify-center mt-5">
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="dismiss()">
                {{ 'registration.consent.showLess' | transloco }}
            </button>
        </div>
        }
    </div>
    }

    <ng-template pTemplate="footer">
        @if (type == 'message' && size !== 'terms') {
        <div class="modal-footer flex justify-center p-0">
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="dismiss()" data-testid="modal_confirm">
                {{ 'common.confirm' | transloco }}
            </button>
        </div>
        }

        @if (type == 'subscription-block') {
        <div class="modal-footer flex justify-center p-0 gap-3">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="goToSubscriptions()">
                {{ 'account.subscriptions' | transloco }}
            </button>
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="dismiss()" data-testid="modal_confirm">
                {{ 'common.confirm' | transloco }}
            </button>
        </div>
        }

        @if (type == 'confirm' || type == 'confirm-delete') {
        <div class="modal-footer flex justify-center p-0 gap-3">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="dismiss()" data-testid="modal_cancel">
                {{ 'common.cancel' | transloco }}
            </button>
            @if (type == 'confirm') {
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="emitModalAction('confirm')" data-testid="modal_confirm">
                {{ 'common.confirm' | transloco }}
            </button>
            }
            @if (type == 'confirm-delete') {
            <button type="button" class="button button-sm danger min-width-150 hover-hl" (click)="emitModalAction('confirm')" data-testid="modal_delete">
                {{ 'common.button.delete' | transloco }}
            </button>
            }
        </div>
        }

        @if (type == 'cancel-subscription') {
        <div class="modal-footer flex justify-center p-0 gap-3">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="dismiss()" data-testid="modal_cancel">
                {{ 'common.cancel' | transloco }}
            </button>
            <button type="button" class="button button-sm danger min-width-150 hover-hl" (click)="emitModalAction('confirm')" data-testid="modal_confirm-danger">
                {{ 'common.button.cancel_subscription' | transloco }}
            </button>
        </div>
        }

        @if (type == 'binge-inactivity') {
        <div class="modal-footer flex flex-col justify-center p-0 gap-3">
            <div class="flex binge-inactivity w-full">
                <button type="button" class="button button-sm secondary min-width-150 hover-hl w-full"
                    (click)="emitModalAction('disable-sleep-modal')">
                    {{ 'player.binge.inactivity_prompt.stop_asking' | transloco }}
                </button>
                <button type="button" class="button button-sm primary min-width-150 hover-hl w-full" (click)="emitModalAction('still-awake')"
                    data-testid="modal_confirm">
                    {{ 'player.binge.inactivity_prompt.dismiss' | transloco }}
                </button>
            </div>
        </div>
        }

        @if (type == 'change-profile') {
        <div class="modal-footer flex justify-center p-0 gap-3">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="emitModalAction('confirm')" data-testid="modal_confirm">
                {{ 'common.confirm' | transloco }}
            </button>
            <button type="button" class="button button-sm primary min-width-150 hover-hl" (click)="emitModalAction('change-profile')"
                data-testid="modal_change-profile">
                {{ 'profile.change' | transloco }}
            </button>
        </div>
        }

        @if (type == 'player-error') {
        <div class="modal-footer flex justify-center p-0">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="emitModalAction('confirm-player-close')"
                data-testid="error_dismiss">
                {{ 'common.confirm' | transloco }}
            </button>
        </div>
        }

        @if (type == 'content-portability') {
        <div class="modal-footer flex justify-center p-0 gap-3">
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="emitModalAction('outside-of-croatia')">
                {{ 'content_portability.country.outside_of_croatia' | transloco }}
            </button>
            <button type="button" class="button button-sm secondary min-width-150 hover-hl" (click)="emitModalAction('croatia')">
                {{ 'content_portability.country.croatia' | transloco }}
            </button>
        </div>
        }
    </ng-template>
</p-dialog>
